import * as React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {
  LayoutProps, LayoutStates, SamlRequestVO,
} from './typing';
import { LogoutOutlined } from '@ant-design/icons';
import { Button, notification, Select, Spin } from 'antd';
import storage from '../../services/storage';
import * as layoutAction from './action/layout';
import VisitedForm from './component/visited-form';
import { injectIntl } from 'react-intl';
import LOGIN_MESSAGE_KEY from '../../common/lang/login-message-key';
import * as paths from '../../common/paths';
import { LoginUserVO } from '../login/typing';
import { isMobile } from '../../common/navigator';

require('./layout.scss');

/**
 * Layout 界面
 *
 * @author Jiawei Chen
 * @since 18/5/2022
 */
class Login extends React.PureComponent<LayoutProps, LayoutStates> {
  constructor(props) {
    super(props);
    this.state = {
      isFetchingSaml: false,
      isLogoutClicked: false,
    };
  }

  private isSubmitted: boolean = false;

  /**
   * 控件mount后执行
   */
  async componentDidMount () {
    // 从 storage 中获取登录用户信息
    const userInfo = storage.getUserInfo() as LoginUserVO;
    if (!userInfo) {
      // 如果登录用户信息不存在则跳转到登录界面
      this.gotoLogin();
      return;
    }
    // 如果用户未统一协议公告，则跳转到协议公告页面
    if (!userInfo.announcementInfo || !userInfo.announcementInfo.agreed) {
      this.gotoAnnouncement();
      return;
    }
    let visitedLinkConfigs = [], learnLinkConfigs = [];
    // 获取学习培训连接配置信息
    await layoutAction.fetchLearnLinkConfig()
      .then(result => {
        if (result) {
          if (result.code === '0' && result.data) {
            learnLinkConfigs = result.data;
          } else {
            this.showError(result.message);
          }
        }
      }).catch(err => {
        if (err && err.response && err.response.status == 403) {
          this.gotoLogin();
        } else {
          this.showError(this.fmtMessage(LOGIN_MESSAGE_KEY.NETWORK_ERROR));
        }
      });
    // 获取用户查询业绩的连接配置信息
    await layoutAction.fetchVisitedLinkConfig()
        .then(result => {
          if (result) {
            if (result.code === '0' && result.data) {
              visitedLinkConfigs = result.data;
            } else {
              this.showError(result.message);
            }
          }
        }).catch(err => {
          if (err && err.response && err.response.status == 403) {
            this.gotoLogin();
          } else {
            this.showError(this.fmtMessage(LOGIN_MESSAGE_KEY.NETWORK_ERROR));
          }
        });

    this.setState({
      learnLinkConfigs,
      visitedLinkConfigs,
    });
  }

  private fmtMessage = (id, params = {}) => {
    const { intl } = this.props;
    return intl.formatMessage({id}, params);
  };

  showError = (description: string) => {
    notification['error']({
      message: null,
      description,
      placement: 'top',
    });
  }

  componentDidUpdate(prevProps: Readonly<LayoutProps>, prevState: Readonly<LayoutStates>, snapshot?: any): void {
    const { selectedVisitedLinkConfig } = this.state;
    // if(!this.isSubmitted && selectedVisitedLinkConfig) {
    //   (document.getElementById(selectedVisitedLinkConfig.gatewayParamName) as any).submit();
    //   this.isSubmitted = true;
    // }
  }

  private onLogoutClicked = () => {
    this.setState({
      isLogoutClicked: true,
    }, this.doLogoutClicked);
  };

  private doLogoutClicked = () => {
    layoutAction.logout().then(result => {
      if (result) {
        if (result.code === '0' && result.data) {
          this.gotoLogin();
        } else {
          this.showError(result.message);
        }
      }
    }).catch(err => {
      if (err && err.response && err.response.data) {
        this.showError(err.response.data);
      } else {
        this.showError(this.fmtMessage(LOGIN_MESSAGE_KEY.NETWORK_ERROR));
      }
      this.setState({ isLogoutClicked: false });
    });
  };

  private gotoLogin = () => {
    storage.removeInfo();
    const { history } = this.props;
    history.push(paths.LOGIN_PATH);
  };

  private gotoAnnouncement = () => {
    const { history } = this.props;
    history.push(paths.ANNOUNCEMENT_PATH);
  };

  private onTrainningChanged = (value: string, option: any) => {
    if (value === '1' || !option.value) {
      return;
    }
    if (isMobile) {
       document.location.href = option.value;
    } else {
      window.open(option.value, '_blank', 'noopener,noreferrer');
    }
  };

  private onVisitedClick = (value: string, option: any) => {
    let userInfo = storage.getUserInfo() as any;
    if (!userInfo) {
      this.gotoLogin();
    }
    const { visitedLinkConfigs } = this.state;
    if (!visitedLinkConfigs) {
      return;
    }
    let selectedVisitedLinkConfig = visitedLinkConfigs.find(c => c.serviceName === value);
    if (!selectedVisitedLinkConfig) {
      return;
    }
    this.setState({
    }, () => this.doFetchOauth2(selectedVisitedLinkConfig));
  };

  private doFetchSaml = (adaNumber, selectedVisitedLinkConfig) => {
    let samlRequestVO: SamlRequestVO = {
      adaNumber: adaNumber,
      channel: selectedVisitedLinkConfig.channel,
      urlType: selectedVisitedLinkConfig.urlType,
    };
    layoutAction.fetchSaml(samlRequestVO)
        .then(result => {
          if (result) {
            if (result.code === '0' && result.data) {
              this.isSubmitted = false;
              this.setState({
                selectedVisitedLinkConfig,
                saml: result.data,
              });
            } else {
              this.showError(result.message);
            }
          }
          this.setState({
            isFetchingSaml: false,
          });
        }).catch(err => {
          if (err && err.response && err.response.status == 403) {
            this.gotoLogin();
          } else {
            this.showError(this.fmtMessage(LOGIN_MESSAGE_KEY.NETWORK_ERROR));
          }
          this.setState({
            isFetchingSaml: false,
          });
        });
  }
  private doFetchOauth2 = (selectedVisitedLinkConfig) => {
    const parts=selectedVisitedLinkConfig.serviceName.split('-');
    let pageName=parts[parts.length - 1].toLowerCase();
    layoutAction.fetchPageUrl(pageName)
        .then(result => {
          if (result) {
            if (result.code === '0' && result.data) {
              window.open(result.data,isMobile? '_self' : '_blank');
            } else {
              this.showError(result.message);
            }
          }
          this.setState({
          });
        }).catch(err => {
      if (err && err.response && err.response.status == 403) {
        this.gotoLogin();
      } else {
        this.showError(this.fmtMessage(LOGIN_MESSAGE_KEY.NETWORK_ERROR));
      }
      this.setState({
      });
    });
  }

  render() {
    const userInfo = storage.getUserInfo() as any;
    const { isFetchingSaml, isLogoutClicked } = this.state;
    if (!userInfo) {
      return <></>;
    }
    const { learnLinkConfigs, visitedLinkConfigs,
      selectedVisitedLinkConfig } = this.state;
    const { Option } = Select;
    return (
      <>
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }} className='pysix-layout'>
          <div style={{ height: '90px', backgroundColor: 'rgb(36, 40, 107)', display: 'flex', alignItems: 'center' }}>
            <div className="top-title">{this.fmtMessage(LOGIN_MESSAGE_KEY.LOGIN_TITLE)}</div>
            <div style={{ flexGrow: 2 }}></div>
            <div className="top-user-info">
              {userInfo? userInfo.username : ''} {this.fmtMessage(LOGIN_MESSAGE_KEY.GREET_TXT)}
              <Button shape='round' icon={<LogoutOutlined />} onClick={this.onLogoutClicked} loading={isLogoutClicked}>
                {this.fmtMessage(LOGIN_MESSAGE_KEY.LOGOUT_BUTTON)}
              </Button>
            </div>
          </div>
          <div style={{ height: '90px', flexGrow: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div className='service-button-container'>
              <Select defaultValue="1" style={{ width: 160 }} onChange={this.onTrainningChanged}>
                <Option value="1">培训项目</Option>
                {
                  learnLinkConfigs && learnLinkConfigs.map(config => <Option key={`target-learn-${config.learnName}`} value={config.learnUrl}>-{config.learnName}</Option>)
                }
              </Select>
              <Select defaultValue="1" style={{ width: 160 }} onChange={this.onVisitedClick} >
                <Option value="1">业务中心</Option>
                {
                  visitedLinkConfigs && visitedLinkConfigs.map(config => <Option key={`target-service-${config.serviceName}`} value={config.serviceName}>-{config.serviceName}</Option>)
                }
              </Select>
            </div>
            <div className='workspace-container'></div>
          </div>
          <div className='bottom-container'>
            <div className='copyright-container' dangerouslySetInnerHTML={{ __html: this.fmtMessage(LOGIN_MESSAGE_KEY.COPYRIGHT_DESCRIPTION)}}></div>
          </div>
        </div>
      </>
    );
  }
}

(Login as React.ComponentType).defaultProps = {
  loading: true,
  location: { pathname: '' },
};

(Login as React.ComponentType<any>).contextTypes = {
  numeric: PropTypes.object,
  intl: PropTypes.object,
};

export default injectIntl(withRouter(Login));
